import { useContext, useEffect, useMemo, useState } from 'react'
import DateFilterToolbar from 'Presentation/Components/CustomToolbar/DateFilter'

import { useNavigate } from 'react-router-dom'
import { UIContext } from 'Context/UI'
import { TableContext } from 'Context/Table'

import { useContractStore } from 'Store/Contract'
import Swal from 'sweetalert2'
import { shallow } from 'zustand/shallow'
import { OEMFilter } from 'Configuration/OEMFilter'

import { useLang } from '_metronic/i18n/Metronici18n'

export const PAGE_SIZE = 10

const ViewModel = () => {
	const lang = useLang()
	const navigate = useNavigate()
	const { updateLoading, updateError } = useContext(TableContext)
	const { setShowContentToolbar, setCustomContentToolbar } = useContext(UIContext)
	const { rawData, stat, getAll, getStat, clearState } = useContractStore(
		state => ({
			rawData: state.data,
			stat: state.stat,
			getAll: state.getAll,
			getStat: state.getStat,
			clearState: state.clearState,
		}),
		shallow
	)

	const [currentPage, setCurrentPage] = useState<number>(1)
	const [currentStatus, setCurrentStatus] = useState<string[]>(['paymentCompleted'])
	const [isLoading, setIsLoading] = useState<boolean>(false)

	const data = useMemo(
		() =>
			rawData
				.map((d: any) => ({
					...d,
					items: d.items
						.filter((item: any) => item.isFixed)
						.map((item: any) => ({
							...item,
							product: item?.oemRequestItem?.product,
						})),
				}))
				.splice((currentPage - 1) * PAGE_SIZE, PAGE_SIZE),
		[rawData, currentPage]
	)

	const statusFilters = useMemo(
		() => [
			{
				// @ts-ignore
				label: OEMFilter['all'][lang],
				value: [OEMFilter['all']['value']],
			},
			{
				// @ts-ignore
				label: OEMFilter['payment'][lang],
				value: [OEMFilter['payment']['value']],
				number: stat?.paymentCompleted,
			},
			{
				// @ts-ignore
				label: OEMFilter['sampleApproved'][lang],
				value: [OEMFilter['sampleApproved']['value']],
				number: stat?.sampleApproved,
			},
			{
				// @ts-ignore
				label: OEMFilter['inProduction'][lang],
				value: [OEMFilter['inProduction']['value']],
				number: stat?.inProduction,
			},
			{
				// @ts-ignore
				label: OEMFilter['delivered'][lang],
				value: [OEMFilter['delivered']['value'], OEMFilter['completed']['value']],
				number: (stat?.delivered ?? 0) + (stat?.completed ?? 0),
			},
			// {
			// 	// @ts-ignore
			// 	label: OEMFilter['completed'][lang],
			// 	value: [OEMFilter['completed']['value']],
			// 	number: stat?.completed,
			// },
			{
				// @ts-ignore
				label: OEMFilter['cancel'][lang],
				value: [OEMFilter['cancel']['value']],
				number: stat?.cancelled,
			},
			{
				// @ts-ignore
				label: OEMFilter['dispute'][lang],
				value: [OEMFilter['dispute']['value']],
				number: stat?.dispute,
			},
		],
		[lang, stat]
	)

	const onChangeFilterStatus = (status: string[]) => {
		setCurrentStatus(status)
	}

	const fetchData = () => {
		setIsLoading(true)
		updateLoading(true)
		updateError(false)

		getAll({ status: currentStatus }).then(({ success, data }) => {
			if (!success) {
				Swal.fire({
					icon: 'error',
					title: 'เกิดข้อผิดพลาด',
					text: data ?? 'ไม่สามารถดึงข้อมูลได้',
					showConfirmButton: false,
					timer: 1500,
					customClass: {
						confirmButton: 'btn btn-sm btn-kumopack-primary-600 text-kumopack-base-white',
					},
				}).then(() => {
					updateError(true)
				})
			} else {
				setIsLoading(false)
				updateLoading(false)
				updateError(false)
			}
		})
		getStat()
	}

	const onViewDetail = (uuId: string) => {
		navigate(`/oem/productions/${uuId}`)
	}

	const goToPage = (page: number | null) => {
		if (page) {
			setCurrentPage(page)
			document.getElementById('production-list-anchor')?.scrollIntoView({
				behavior: 'smooth',
				block: 'center',
			})
		}
	}

	useEffect(() => {
		fetchData()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [currentStatus])

	useEffect(() => {
		setShowContentToolbar(true)
		setCustomContentToolbar(<DateFilterToolbar />)

		return () => {
			setShowContentToolbar(true)
			setCustomContentToolbar(null)
			clearState()
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return {
		currentPage,
		isLoading,
		statusFilters: statusFilters.map(status => ({
			label: status.label,
			isActive: status.value.some(v => currentStatus.includes(v)),
			value: status.value,
			number: status.number,
			numberColor: 'green' as 'green',
		})),
		data,
		totalData: rawData.length,
		onViewDetail,
		goToPage,
		onChangeFilterStatus,
	}
}

export default ViewModel
